export default "/images/fde805f5bbf3129f4a8c46a0802487d3.avif";